import { withProps, compose, withHandlers } from 'recompose'
import PromotionSlider from './PromotionSlider'
import withDynamicDeviceType from 'components/common/hoc/withDynamicDeviceType'
import { processPromotionLink } from '../PromotionsList/helpers'
import { PROMOTIONS_CREATIVE_MAP } from '../PromotionsList/constants'
import { googleAnalyticPromotionClicks } from 'actions/googleAnalytic'
import { connect } from 'react-redux'
import { navigateToPromo } from '../PromotionsList/actions'

const withPromotionClickHandler = withHandlers({
  handlePromotionClick: ({ googleAnalyticPromotionClicks, position, storePromotions, regionName, navigateToPromo }) =>
    ({ item, index }) => {
      const { promotionLinkUrl } = item
      navigateToPromo(processPromotionLink({ promotionLinkUrl, regionName }))

      storePromotions ?
        googleAnalyticPromotionClicks({ item, index, creative: PROMOTIONS_CREATIVE_MAP[position] }) :
        googleAnalyticPromotionClicks({ item, index })
    }
})

const withCarouselConfig = withProps(({ deviceType }) => {
  const baseConfig = {
    autoplay: false,
    infinite: false,
    variableWidth: false,
    slidesToScroll: 1
  }

  const desktopConfig = {
    ...baseConfig,
    dots: true,
    draggable: false,
    arrows: true,
    slidesToShow: 4,
    centerMode: false
  }

  const tabletConfig = {
    ...baseConfig,
    arrows: false,
    dots: true,
    slidesToShow: 3,
    draggable: true,
    centerMode: false
  }

  const phoneConfig = {
    ...baseConfig,
    arrows: false,
    dots: false,
    slidesToShow: 1,
    draggable: true,
    centerMode: true
  }

  return {
    carouselConfig: deviceType === 'PHONE'
      ? phoneConfig : deviceType === 'TABLET'
        ? tabletConfig : desktopConfig
  }
})

export default compose(
  connect(null, { googleAnalyticPromotionClicks, navigateToPromo }),
  withPromotionClickHandler,
  withDynamicDeviceType,
  withCarouselConfig
)(PromotionSlider)
